import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import '../styles/Services.css';
import { sendInvoiceRequest } from '../utils/invoiceRequest';

const initialFormData = {
  name: '',
  email: '',
  phone: '',
  type: 'GIS Consulting',
  company: '',
  moreInformation: '',
};

function Services() {
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [inlineSubmitted, setInlineSubmitted] = useState(false);
  const [popupSubmitted, setPopupSubmitted] = useState(false);
  const [inlineSubmitting, setInlineSubmitting] = useState(false);
  const [popupSubmitting, setPopupSubmitting] = useState(false);
  const [inlineError, setInlineError] = useState('');
  const [popupError, setPopupError] = useState('');
  const [inlineFormData, setInlineFormData] = useState(initialFormData);
  const [popupFormData, setPopupFormData] = useState(initialFormData);

  const handleInlineFormChange = (event) => {
    const { name, value } = event.target;
    setInlineSubmitted(false);
    setInlineError('');
    setInlineFormData((previous) => ({ ...previous, [name]: value }));
  };

  const handlePopupFormChange = (event) => {
    const { name, value } = event.target;
    setPopupSubmitted(false);
    setPopupError('');
    setPopupFormData((previous) => ({ ...previous, [name]: value }));
  };

  const handleInlineFormSubmit = async (event) => {
    event.preventDefault();
    setInlineSubmitting(true);
    setInlineError('');
    try {
      await sendInvoiceRequest(inlineFormData, 'Services Inline');
      setInlineSubmitted(true);
      setInlineFormData(initialFormData);
    } catch (error) {
      setInlineSubmitted(false);
      setInlineError('Unable to send right now. Please try again in a moment.');
    } finally {
      setInlineSubmitting(false);
    }
  };

  const handlePopupFormSubmit = async (event) => {
    event.preventDefault();
    setPopupSubmitting(true);
    setPopupError('');
    try {
      await sendInvoiceRequest(popupFormData, 'Services Popup');
      setPopupSubmitted(true);
      setPopupFormData(initialFormData);
    } catch (error) {
      setPopupSubmitted(false);
      setPopupError('Unable to send right now. Please try again in a moment.');
    } finally {
      setPopupSubmitting(false);
    }
  };

  const openPopupForm = () => {
    setPopupSubmitted(false);
    setPopupError('');
    setIsPopupOpen(true);
  };

  const closePopupForm = () => {
    setIsPopupOpen(false);
  };

  const services = [
    {
      title: 'GIS Consulting',
      description:
        'Strategic GIS guidance to help you plan, design, and deliver mapping solutions that align with your business or project goals.',
    },
    {
      title: 'Cartography',
      description: (
        <>
          Custom-made map design tailored to your project goals, audience, and visual style for clear and compelling spatial communication. View my{' '}
          <Link to="/portfolio">portfolio</Link> for examples.
        </> 
      ),
    },
  ];

  return (
    <section className="services-page" aria-labelledby="services-title">
      <div className="services-shell">
        <header className="services-hero">
          <p className="services-kicker">What I Offer</p>
          <h1 id="services-title">GIS Services</h1>
          <p className="services-intro">
            I provide practical geospatial services for teams and organizations that need
            reliable mapping systems, clean data, and clear implementation support.
          </p>
        </header>

        <div className="services-grid">
          {services.map((service) => (
            <article className="service-card" key={service.title}>
              <h2>{service.title}</h2>
              <p>{service.description}</p>
            </article>
          ))}
        </div>

        <div className="services-cta">
          <h2>Interested in working together?</h2>
          <p>Reach out to discuss your project or request an invoice.</p>

        
          <form id="request-form" className="services-request-form" onSubmit={handleInlineFormSubmit}>
            <label htmlFor="inline-name">Name</label>
            <input
              id="inline-name"
              name="name"
              type="text"
              value={inlineFormData.name}
              onChange={handleInlineFormChange}
              required
            />

            <label htmlFor="inline-email">Email</label>
            <input
              id="inline-email"
              name="email"
              type="email"
              value={inlineFormData.email}
              onChange={handleInlineFormChange}
              required
            />

            <label htmlFor="inline-phone">Phone (optional)</label>
            <input
              id="inline-phone"
              name="phone"
              type="tel"
              value={inlineFormData.phone}
              onChange={handleInlineFormChange}
            />

            <label htmlFor="inline-type">Type</label>
            <select id="inline-type" name="type" value={inlineFormData.type} onChange={handleInlineFormChange}>
              <option>GIS Consulting</option>
              <option>Cartography</option>
            </select>

            <label htmlFor="inline-company">Company</label>
            <input
              id="inline-company"
              name="company"
              type="text"
              value={inlineFormData.company}
              onChange={handleInlineFormChange}
              required
            />

            <label htmlFor="inline-moreInformation">More information</label>
            <textarea
              id="inline-moreInformation"
              name="moreInformation"
              rows="4"
              value={inlineFormData.moreInformation}
              onChange={handleInlineFormChange}
              required
            />

            <button type="submit" className="services-submit-btn" disabled={inlineSubmitting}>
              {inlineSubmitting ? 'Sending...' : 'Submit Request'}
            </button>
            {inlineError && (
              <p className="services-submit-error">{inlineError}</p>
            )}
            {inlineSubmitted && (
              <p className="services-submit-message">Thank you. Your request has been sent.</p>
            )}
          </form>
<br></br>
          <div className="services-cta-actions">
            <button
              type="button"
              className="services-cta-btn"
              onClick={openPopupForm}
              aria-haspopup="dialog"
              aria-expanded={isPopupOpen}
            >
              Invoice Request
            </button>
          </div>

        </div>
      </div>

      {isPopupOpen && (
        <div className="services-modal-backdrop" onClick={closePopupForm}>
          <div
            className="services-modal"
            role="dialog"
            aria-modal="true"
            aria-labelledby="services-modal-title"
            onClick={(event) => event.stopPropagation()}
          >
            <button type="button" className="services-modal-close" onClick={closePopupForm} aria-label="Close request form">
              x
            </button>
            <h3 id="services-modal-title">Invoice Request</h3>

            <form className="services-request-form services-request-form-modal" onSubmit={handlePopupFormSubmit}>
              <label htmlFor="modal-name">Name</label>
              <input
                id="modal-name"
                name="name"
                type="text"
                value={popupFormData.name}
                onChange={handlePopupFormChange}
                required
              />

              <label htmlFor="modal-email">Email</label>
              <input
                id="modal-email"
                name="email"
                type="email"
                value={popupFormData.email}
                onChange={handlePopupFormChange}
                required
              />

              <label htmlFor="modal-phone">Phone (optional)</label>
              <input
                id="modal-phone"
                name="phone"
                type="tel"
                value={popupFormData.phone}
                onChange={handlePopupFormChange}
              />

              <label htmlFor="modal-type">Type</label>
              <select id="modal-type" name="type" value={popupFormData.type} onChange={handlePopupFormChange}>
                <option>GIS Consulting</option>
                <option>Cartography</option>
              </select>

              <label htmlFor="modal-company">Company</label>
              <input
                id="modal-company"
                name="company"
                type="text"
                value={popupFormData.company}
                onChange={handlePopupFormChange}
                required
              />

              <label htmlFor="modal-moreInformation">More information</label>
              <textarea
                id="modal-moreInformation"
                name="moreInformation"
                rows="4"
                value={popupFormData.moreInformation}
                onChange={handlePopupFormChange}
                required
              />

              <button type="submit" className="services-submit-btn" disabled={popupSubmitting}>
                {popupSubmitting ? 'Sending...' : 'Submit Request'}
              </button>
              {popupError && (
                <p className="services-submit-error">{popupError}</p>
              )}
              {popupSubmitted && (
                <p className="services-submit-message">Thank you. Your request has been sent.</p>
              )}
            </form>
          </div>
        </div>
      )}
    </section>
  );

}

export default Services;
